export default __webpack_public_path__ + "static/media/logout.6bb83723.svg";